import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";

export const allocationApi = createApi({
	reducerPath: "allocation",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getAllocation: builder.query({
			query: ({ year, month }) =>
				`/allocation/calendar?year=${year}&month=${month}`,
			transformResponse: (responseData) => {
				const calendarData = responseData?.data ?? responseData;

				if (Array.isArray(calendarData)) {
					return calendarData;
				}

				if (Array.isArray(calendarData?.result)) {
					return calendarData.result;
				}

				return [];
			},
		}),
		getOrderDataByDate: builder.query({
			query: ({ travelDate }) =>
				`/orders/queryOrderDataByDate?&travelDate=${travelDate}`,
		}),
		getExportAllocationDataByDateAndUser: builder.query({
			query: ({ startDate, endDate, userId }) => {
				const params = new URLSearchParams({
					startDate,
					endDate,
				});

				if (userId) {
					params.set("userId", userId);
				}

				return `/allocation/queryExportAllocationDataByDateAndUser?${params.toString()}`;
			},
			transformResponse: (responseData) => {
				return responseData?.data ?? responseData ?? [];
			},
		}),
		getAllocationDetail: builder.query({
			query: ({ productId, travelDate }) =>
				`/orders/queryOrderData?productId=${productId}&travelDate=${travelDate}`,
		}),
		getOrderDataByDateAndPid: builder.query({
			query: ({ productId, travelDate }) =>
				`/orders/queryOrderData?productId=${productId}&travelDate=${travelDate}`,
			transformResponse: (responseData) => {
				return responseData;
			},
		}),
		getAllocationByDate: builder.query({
			query: (travelDate) =>
				`/allocation/queryAllocationDataByDate?travelDate=${travelDate}`,
		}),
		getAllocationByDateAndProduct: builder.query({
			query: ({ productId, travelDate }) =>
				`/allocation/queryAllocationDataByDateAndPid?productId=${productId}&travelDate=${travelDate}`,
		}),
		getPickupLocationList: builder.query({
			query: () => `/records/queryUniquePLocation`,
			transformResponse: (responseData) => {
				if (responseData && responseData.data) {
					return responseData.data.result.filter(
						(item) => item !== "" && item !== null
					);
				} else {
					return [];
				}
			},
		}),
		// New clients synchronize confirmed orders with existing allocations.
		updateBatchRecord: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/orders/update_confirmed_order_new",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		addAllocation: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/allocation/insertAllocation",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		generateAiAllocation: builder.mutation({
			query: (initialPost) => ({
				url: "/allocation/ai-suggest",
				method: "POST",
				body: initialPost,
			}),
		}),
		validateAllocationRules: builder.mutation({
			query: (initialPost) => ({
				url: "/allocation/validate-rules",
				method: "POST",
				body: initialPost,
			}),
		}),
		deleteAllocation: builder.mutation({
			query({ productId, travelDate }) {
				return {
					url: `/allocation/deleteAllocationData?product_id=${productId}&travel_date=${travelDate}`,
					method: "DELETE",
				};
			},
		}),
		getTripSummary: builder.query({
			query: () =>
				`dashboard/allocationDataByDate`,
			transformResponse: (responseData) => {
				return responseData;
			},
		}),
	}),
});

export const {
	useGetTripSummaryQuery,
	useGetAllocationQuery,
	useGetOrderDataByDateQuery,
	useGetExportAllocationDataByDateAndUserQuery,
	useGetAllocationDetailQuery,
	useGetOrderDataByDateAndPidQuery,
	useGetAllocationByDateQuery,
	useGetAllocationByDateAndProductQuery,
	useGetPickupLocationListQuery,
	useUpdateBatchRecordMutation,
	useAddAllocationMutation,
	useGenerateAiAllocationMutation,
	useValidateAllocationRulesMutation,
	useDeleteAllocationMutation,
} = allocationApi;
